// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ************************************************************* */
/* ************************************************************* */
/* ** THIS FILE WAS AUTO GENERATED BY utils/figmaExtractor.js ** */
/* **                                                         ** */
/* ** DO NOT ALTER IT MANUALLY - YOUR CHANGES WILL BE LOST!!! ** */
/* ************************************************************* */
/* ************************************************************* */
.typography_default[data-v-05b576ad] {
  color: #334155;
}
.typography_dark[data-v-05b576ad] {
  color: #0f172a;
}
.typography_light[data-v-05b576ad] {
  color: #64748b;
}
.typography_disabled[data-v-05b576ad] {
  color: #6f747c;
}
.typography_success[data-v-05b576ad] {
  color: #11755d;
}
.typography_warning[data-v-05b576ad] {
  color: #aa740b;
}
.typography_error[data-v-05b576ad] {
  color: #c03851;
}
.typography_white[data-v-05b576ad] {
  color: #ffffff;
}
.typography_info[data-v-05b576ad] {
  color: #4769cb;
}
.typography_primary[data-v-05b576ad] {
  color: #692b7e;
}
.typography_black[data-v-05b576ad] {
  color: #262626;
}
.typography_grey[data-v-05b576ad] {
  color: #6f747c;
}
.user_type_allocator[data-v-05b576ad] {
  color: #4E73DF;
}
.user_type_manager[data-v-05b576ad] {
  color: #692B7E;
}
.user_type_service_provider[data-v-05b576ad] {
  color: #475569;
}
.user_type_media_press[data-v-05b576ad] {
  color: #07829D;
}
.user_type_guest[data-v-05b576ad] {
  color: #94A3B8;
}
.user_type_speaker[data-v-05b576ad] {
  color: #40ACD7;
}
.user_type_sponsor[data-v-05b576ad] {
  color: #7968D7;
}
.user_type_iconnections[data-v-05b576ad] {
  color: #B45ED1;
}
.user_type_vendor[data-v-05b576ad] {
  color: #88A1EA;
}
.user_type_staff[data-v-05b576ad] {
  color: #9B71A9;
}
.background_neutral_default[data-v-05b576ad] {
  background-color: #f8fafc;
}
.background_neutral_secondary[data-v-05b576ad] {
  background-color: #f1f5f9;
}
.background_grayscale[data-v-05b576ad] {
  background-color: #f5f6f7;
}
.background_neutral_white[data-v-05b576ad] {
  background-color: #ffffff;
}
.background_primary_brand_color[data-v-05b576ad] {
  background-color: #f0eaf2;
}
.background_info[data-v-05b576ad] {
  background-color: #4e73df;
}
.background_info_subtle[data-v-05b576ad] {
  background-color: #f5f8ff;
}
.background_positive_subtle[data-v-05b576ad] {
  background-color: #f6fffc;
}
.background_positive[data-v-05b576ad] {
  background: linear-gradient(45deg, #1cc19a 0%, #169778 100%);
}
.background_negative[data-v-05b576ad] {
  background-color: #d33d59;
}
.background_negative_subtle[data-v-05b576ad] {
  background-color: #fff5f6;
}
.background_warning[data-v-05b576ad] {
  background-color: #f0a410;
}
.background_warning_subtle[data-v-05b576ad] {
  background-color: #FFFAF2;
}
.border_neutral_default[data-v-05b576ad] {
  border-color: #cbd5e1;
}
.border_neutral_secondary[data-v-05b576ad] {
  border-color: #94a3b8;
}
.border_info[data-v-05b576ad] {
  border-color: #4e73df;
}
.border_negative[data-v-05b576ad] {
  border-color: #d33d59;
}
.border_positive[data-v-05b576ad] {
  border-color: linear-gradient(45deg, #1fd4a9 0%, #1cc19a 100%);
}
.border_success[data-v-05b576ad] {
  border-color: #169778;
}
.border_warning[data-v-05b576ad] {
  border-color: #f0a410;
}
.bold-headline-h1-xl[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 140%;
}
.bold-headline-h2-lg[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 140%;
}
.bold-headline-h3-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 140%;
}
.bold-headline-h4-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 140%;
}
.medium-headline-h1-xl[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 140%;
}
.medium-headline-h2-lg[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 140%;
}
.medium-headline-h3-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 140%;
}
.medium-headline-h4-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
}
.regular-headline-h1-xl[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  line-height: 140%;
}
.regular-headline-h2-lg[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 140%;
}
.regular-headline-h3-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 140%;
}
.regular-headline-h4-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 140%;
}
.bold-subtitle-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
}
.bold-subtitle-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 140%;
}
.medium-subtitle-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 135%;
}
.medium-subtitle-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 140%;
}
.regular-subtitle-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 140%;
}
.regular-subtitle-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
}
.bold-body-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
}
.bold-body-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
}
.medium-body-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
}
.medium-body-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
}
.regular-body-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
}
.regular-body-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
}
.bold-caption-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 140%;
}
.bold-caption-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 140%;
}
.medium-caption-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
}
.medium-caption-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 140%;
}
.regular-caption-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
}
.regular-caption-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 140%;
}
.bold-overline-xl[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
}
.bold-overline-lg[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
}
.bold-overline-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 150%;
}
.bold-overline-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 150%;
}
.medium-overline-xl[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
}
.medium-overline-lg[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
}
.medium-overline-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
}
.medium-overline-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 150%;
}
.regular-overline-xl[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
}
.regular-overline-lg[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
}
.regular-overline-md[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
}
.regular-overline-sm[data-v-05b576ad] {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 150%;
}
.uppercase[data-v-05b576ad] {
  text-transform: uppercase;
}
.capitalize[data-v-05b576ad] {
  text-transform: capitalize;
}
.lowercase[data-v-05b576ad] {
  text-transform: lowercase;
}
.underline[data-v-05b576ad] {
  text-decoration: underline;
}
.margin-top_3xs[data-v-05b576ad] {
  margin-top: 2px;
}
.margin-top_2xs[data-v-05b576ad] {
  margin-top: 4px;
}
.margin-top_xs-df[data-v-05b576ad] {
  margin-top: 8px;
}
.margin-top_sm[data-v-05b576ad] {
  margin-top: 16px;
}
.margin-top_md[data-v-05b576ad] {
  margin-top: 24px;
}
.margin-top_lg[data-v-05b576ad] {
  margin-top: 32px;
}
.margin-top_xl[data-v-05b576ad] {
  margin-top: 40px;
}
.margin-top_2xl[data-v-05b576ad] {
  margin-top: 48px;
}
.margin-top_3xl[data-v-05b576ad] {
  margin-top: 56px;
}
.margin-top_4xl[data-v-05b576ad] {
  margin-top: 64px;
}
.margin-top_5xl[data-v-05b576ad] {
  margin-top: 72px;
}
.margin-top_6xl[data-v-05b576ad] {
  margin-top: 80px;
}
.margin-top_7xl[data-v-05b576ad] {
  margin-top: 128px;
}
.margin-right_3xs[data-v-05b576ad] {
  margin-right: 2px;
}
.margin-right_2xs[data-v-05b576ad] {
  margin-right: 4px;
}
.margin-right_xs-df[data-v-05b576ad] {
  margin-right: 8px;
}
.margin-right_sm[data-v-05b576ad] {
  margin-right: 16px;
}
.margin-right_md[data-v-05b576ad] {
  margin-right: 24px;
}
.margin-right_lg[data-v-05b576ad] {
  margin-right: 32px;
}
.margin-right_xl[data-v-05b576ad] {
  margin-right: 40px;
}
.margin-right_2xl[data-v-05b576ad] {
  margin-right: 48px;
}
.margin-right_3xl[data-v-05b576ad] {
  margin-right: 56px;
}
.margin-right_4xl[data-v-05b576ad] {
  margin-right: 64px;
}
.margin-right_5xl[data-v-05b576ad] {
  margin-right: 72px;
}
.margin-right_6xl[data-v-05b576ad] {
  margin-right: 80px;
}
.margin-right_7xl[data-v-05b576ad] {
  margin-right: 128px;
}
.margin-bottom_3xs[data-v-05b576ad] {
  margin-bottom: 2px;
}
.margin-bottom_2xs[data-v-05b576ad] {
  margin-bottom: 4px;
}
.margin-bottom_xs-df[data-v-05b576ad] {
  margin-bottom: 8px;
}
.margin-bottom_sm[data-v-05b576ad] {
  margin-bottom: 16px;
}
.margin-bottom_md[data-v-05b576ad] {
  margin-bottom: 24px;
}
.margin-bottom_lg[data-v-05b576ad] {
  margin-bottom: 32px;
}
.margin-bottom_xl[data-v-05b576ad] {
  margin-bottom: 40px;
}
.margin-bottom_2xl[data-v-05b576ad] {
  margin-bottom: 48px;
}
.margin-bottom_3xl[data-v-05b576ad] {
  margin-bottom: 56px;
}
.margin-bottom_4xl[data-v-05b576ad] {
  margin-bottom: 64px;
}
.margin-bottom_5xl[data-v-05b576ad] {
  margin-bottom: 72px;
}
.margin-bottom_6xl[data-v-05b576ad] {
  margin-bottom: 80px;
}
.margin-bottom_7xl[data-v-05b576ad] {
  margin-bottom: 128px;
}
.margin-left_3xs[data-v-05b576ad] {
  margin-left: 2px;
}
.margin-left_2xs[data-v-05b576ad] {
  margin-left: 4px;
}
.margin-left_xs-df[data-v-05b576ad] {
  margin-left: 8px;
}
.margin-left_sm[data-v-05b576ad] {
  margin-left: 16px;
}
.margin-left_md[data-v-05b576ad] {
  margin-left: 24px;
}
.margin-left_lg[data-v-05b576ad] {
  margin-left: 32px;
}
.margin-left_xl[data-v-05b576ad] {
  margin-left: 40px;
}
.margin-left_2xl[data-v-05b576ad] {
  margin-left: 48px;
}
.margin-left_3xl[data-v-05b576ad] {
  margin-left: 56px;
}
.margin-left_4xl[data-v-05b576ad] {
  margin-left: 64px;
}
.margin-left_5xl[data-v-05b576ad] {
  margin-left: 72px;
}
.margin-left_6xl[data-v-05b576ad] {
  margin-left: 80px;
}
.margin-left_7xl[data-v-05b576ad] {
  margin-left: 128px;
}
.margin_3xs[data-v-05b576ad] {
  margin: 2px;
}
.margin_2xs[data-v-05b576ad] {
  margin: 4px;
}
.margin_xs-df[data-v-05b576ad] {
  margin: 8px;
}
.margin_sm[data-v-05b576ad] {
  margin: 16px;
}
.margin_md[data-v-05b576ad] {
  margin: 24px;
}
.margin_lg[data-v-05b576ad] {
  margin: 32px;
}
.margin_xl[data-v-05b576ad] {
  margin: 40px;
}
.margin_2xl[data-v-05b576ad] {
  margin: 48px;
}
.margin_3xl[data-v-05b576ad] {
  margin: 56px;
}
.margin_4xl[data-v-05b576ad] {
  margin: 64px;
}
.margin_5xl[data-v-05b576ad] {
  margin: 72px;
}
.margin_6xl[data-v-05b576ad] {
  margin: 80px;
}
.margin_7xl[data-v-05b576ad] {
  margin: 128px;
}
.padding-top_3xs[data-v-05b576ad] {
  padding-top: 2px;
}
.padding-top_2xs[data-v-05b576ad] {
  padding-top: 4px;
}
.padding-top_xs-df[data-v-05b576ad] {
  padding-top: 8px;
}
.padding-top_sm[data-v-05b576ad] {
  padding-top: 16px;
}
.padding-top_md[data-v-05b576ad] {
  padding-top: 24px;
}
.padding-top_lg[data-v-05b576ad] {
  padding-top: 32px;
}
.padding-top_xl[data-v-05b576ad] {
  padding-top: 40px;
}
.padding-top_2xl[data-v-05b576ad] {
  padding-top: 48px;
}
.padding-top_3xl[data-v-05b576ad] {
  padding-top: 56px;
}
.padding-top_4xl[data-v-05b576ad] {
  padding-top: 64px;
}
.padding-top_5xl[data-v-05b576ad] {
  padding-top: 72px;
}
.padding-top_6xl[data-v-05b576ad] {
  padding-top: 80px;
}
.padding-top_7xl[data-v-05b576ad] {
  padding-top: 128px;
}
.padding-right_3xs[data-v-05b576ad] {
  padding-right: 2px;
}
.padding-right_2xs[data-v-05b576ad] {
  padding-right: 4px;
}
.padding-right_xs-df[data-v-05b576ad] {
  padding-right: 8px;
}
.padding-right_sm[data-v-05b576ad] {
  padding-right: 16px;
}
.padding-right_md[data-v-05b576ad] {
  padding-right: 24px;
}
.padding-right_lg[data-v-05b576ad] {
  padding-right: 32px;
}
.padding-right_xl[data-v-05b576ad] {
  padding-right: 40px;
}
.padding-right_2xl[data-v-05b576ad] {
  padding-right: 48px;
}
.padding-right_3xl[data-v-05b576ad] {
  padding-right: 56px;
}
.padding-right_4xl[data-v-05b576ad] {
  padding-right: 64px;
}
.padding-right_5xl[data-v-05b576ad] {
  padding-right: 72px;
}
.padding-right_6xl[data-v-05b576ad] {
  padding-right: 80px;
}
.padding-right_7xl[data-v-05b576ad] {
  padding-right: 128px;
}
.padding-bottom_3xs[data-v-05b576ad] {
  padding-bottom: 2px;
}
.padding-bottom_2xs[data-v-05b576ad] {
  padding-bottom: 4px;
}
.padding-bottom_xs-df[data-v-05b576ad] {
  padding-bottom: 8px;
}
.padding-bottom_sm[data-v-05b576ad] {
  padding-bottom: 16px;
}
.padding-bottom_md[data-v-05b576ad] {
  padding-bottom: 24px;
}
.padding-bottom_lg[data-v-05b576ad] {
  padding-bottom: 32px;
}
.padding-bottom_xl[data-v-05b576ad] {
  padding-bottom: 40px;
}
.padding-bottom_2xl[data-v-05b576ad] {
  padding-bottom: 48px;
}
.padding-bottom_3xl[data-v-05b576ad] {
  padding-bottom: 56px;
}
.padding-bottom_4xl[data-v-05b576ad] {
  padding-bottom: 64px;
}
.padding-bottom_5xl[data-v-05b576ad] {
  padding-bottom: 72px;
}
.padding-bottom_6xl[data-v-05b576ad] {
  padding-bottom: 80px;
}
.padding-bottom_7xl[data-v-05b576ad] {
  padding-bottom: 128px;
}
.padding-left_3xs[data-v-05b576ad] {
  padding-left: 2px;
}
.padding-left_2xs[data-v-05b576ad] {
  padding-left: 4px;
}
.padding-left_xs-df[data-v-05b576ad] {
  padding-left: 8px;
}
.padding-left_sm[data-v-05b576ad] {
  padding-left: 16px;
}
.padding-left_md[data-v-05b576ad] {
  padding-left: 24px;
}
.padding-left_lg[data-v-05b576ad] {
  padding-left: 32px;
}
.padding-left_xl[data-v-05b576ad] {
  padding-left: 40px;
}
.padding-left_2xl[data-v-05b576ad] {
  padding-left: 48px;
}
.padding-left_3xl[data-v-05b576ad] {
  padding-left: 56px;
}
.padding-left_4xl[data-v-05b576ad] {
  padding-left: 64px;
}
.padding-left_5xl[data-v-05b576ad] {
  padding-left: 72px;
}
.padding-left_6xl[data-v-05b576ad] {
  padding-left: 80px;
}
.padding-left_7xl[data-v-05b576ad] {
  padding-left: 128px;
}
.padding_3xs[data-v-05b576ad] {
  padding: 2px;
}
.padding_2xs[data-v-05b576ad] {
  padding: 4px;
}
.padding_xs-df[data-v-05b576ad] {
  padding: 8px;
}
.padding_sm[data-v-05b576ad] {
  padding: 16px;
}
.padding_md[data-v-05b576ad] {
  padding: 24px;
}
.padding_lg[data-v-05b576ad] {
  padding: 32px;
}
.padding_xl[data-v-05b576ad] {
  padding: 40px;
}
.padding_2xl[data-v-05b576ad] {
  padding: 48px;
}
.padding_3xl[data-v-05b576ad] {
  padding: 56px;
}
.padding_4xl[data-v-05b576ad] {
  padding: 64px;
}
.padding_5xl[data-v-05b576ad] {
  padding: 72px;
}
.padding_6xl[data-v-05b576ad] {
  padding: 80px;
}
.padding_7xl[data-v-05b576ad] {
  padding: 128px;
}
.width_xs-df[data-v-05b576ad] {
  width: 8px;
}
.width_sm[data-v-05b576ad] {
  width: 16px;
}
.width_md[data-v-05b576ad] {
  width: 24px;
}
.width_lg[data-v-05b576ad] {
  width: 32px;
}
.width_xl[data-v-05b576ad] {
  width: 40px;
}
.width_2xl[data-v-05b576ad] {
  width: 48px;
}
.width_3xl[data-v-05b576ad] {
  width: 56px;
}
.width_4xl[data-v-05b576ad] {
  width: 64px;
}
.width_5xl[data-v-05b576ad] {
  width: 72px;
}
.width_6xl[data-v-05b576ad] {
  width: 80px;
}
.width_7xl[data-v-05b576ad] {
  width: 128px;
}
.width_xs-df-important[data-v-05b576ad] {
  width: 8px !important;
}
.width_sm-important[data-v-05b576ad] {
  width: 16px !important;
}
.width_md-important[data-v-05b576ad] {
  width: 24px !important;
}
.width_lg-important[data-v-05b576ad] {
  width: 32px !important;
}
.width_xl-important[data-v-05b576ad] {
  width: 40px !important;
}
.width_2xl-important[data-v-05b576ad] {
  width: 48px !important;
}
.width_3xl-important[data-v-05b576ad] {
  width: 56px !important;
}
.width_4xl-important[data-v-05b576ad] {
  width: 64px !important;
}
.width_5xl-important[data-v-05b576ad] {
  width: 72px !important;
}
.width_6xl-important[data-v-05b576ad] {
  width: 80px !important;
}
.width_7xl-important[data-v-05b576ad] {
  width: 128px !important;
}
.height_xs-df[data-v-05b576ad] {
  height: 8px;
}
.height_sm[data-v-05b576ad] {
  height: 16px;
}
.height_md[data-v-05b576ad] {
  height: 24px;
}
.height_lg[data-v-05b576ad] {
  height: 32px;
}
.height_xl[data-v-05b576ad] {
  height: 40px;
}
.height_2xl[data-v-05b576ad] {
  height: 48px;
}
.height_3xl[data-v-05b576ad] {
  height: 56px;
}
.height_4xl[data-v-05b576ad] {
  height: 64px;
}
.height_5xl[data-v-05b576ad] {
  height: 72px;
}
.height_6xl[data-v-05b576ad] {
  height: 80px;
}
.height_7xl[data-v-05b576ad] {
  height: 128px;
}
.height_xs-df-important[data-v-05b576ad] {
  height: 8px !important;
}
.height_sm-important[data-v-05b576ad] {
  height: 16px !important;
}
.height_md-important[data-v-05b576ad] {
  height: 24px !important;
}
.height_lg-important[data-v-05b576ad] {
  height: 32px !important;
}
.height_xl-important[data-v-05b576ad] {
  height: 40px !important;
}
.height_2xl-important[data-v-05b576ad] {
  height: 48px !important;
}
.height_3xl-important[data-v-05b576ad] {
  height: 56px !important;
}
.height_4xl-important[data-v-05b576ad] {
  height: 64px !important;
}
.height_5xl-important[data-v-05b576ad] {
  height: 72px !important;
}
.height_6xl-important[data-v-05b576ad] {
  height: 80px !important;
}
.height_7xl-important[data-v-05b576ad] {
  height: 128px !important;
}
.grid-grid-600[data-v-05b576ad] {
  height: 960px;
  width: 600px;
  padding-top: 64px;
  padding-left: 0px;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
  background: #F4F6FC;
}
.grid-grid-900[data-v-05b576ad] {
  height: 960px;
  width: 900px;
  padding-top: 64px;
  padding-left: 0px;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
  background: #F4F6FC;
}
.grid-grid-1240[data-v-05b576ad] {
  height: 960px;
  width: 1240px;
  padding-top: 64px;
  padding-left: 0px;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
  background: #F4F6FC;
}
.grid-grid-1440[data-v-05b576ad] {
  height: 960px;
  width: 1440px;
  padding-top: 64px;
  padding-left: 0px;
  padding-color: white;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
  background: #F4F6FC;
}
.grid-grid-600-sidebar[data-v-05b576ad] {
  height: 960px;
  width: 600px;
  padding-top: 64px;
  padding-left: 80px;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
  background: #F4F6FC;
}
.grid-grid-900-sidebar[data-v-05b576ad] {
  height: 960px;
  width: 900px;
  padding-top: 64px;
  padding-left: 80px;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
  background: #F4F6FC;
}
.grid-grid-1240-sidebar[data-v-05b576ad] {
  height: 960px;
  width: 1240px;
  padding-top: 64px;
  padding-left: 296px;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
  background: #F4F6FC;
}
.grid-grid-1440-sidebar[data-v-05b576ad] {
  height: 960px;
  width: 1440px;
  padding-top: 64px;
  padding-left: 296px;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
  background: #F4F6FC;
}
.gray-shadow-xs[data-v-05b576ad] {
  box-shadow: 2px 4px 12px -2px #F1F5F9;
}
.gray-shadow-sm-df[data-v-05b576ad] {
  box-shadow: 2px 4px 24px -4px #E2E8F0;
}
.gray-shadow-md[data-v-05b576ad] {
  box-shadow: 2px 4px 24px -4px #E2E8F0;
}
.gray-shadow-lg[data-v-05b576ad] {
  box-shadow: 4px 16px 32px -12px #F1F5F9, 2px 24px 48px #F1F5F9;
}
.gray-shadow-xl[data-v-05b576ad] {
  box-shadow: 8px 24px 48px -16px #F1F5F9, 4px 32px 64px #F1F5F9;
}
.inner-shadow-xs-df[data-v-05b576ad] {
  box-shadow: inset 0px 2px 8px -2px #E2E8F0;
}
.inner-shadow-sm[data-v-05b576ad] {
  box-shadow: inset 2px 4px 16px #E2E8F0;
}
.inner-shadow-md[data-v-05b576ad] {
  box-shadow: inset 4px 8px 24px #E2E8F0;
}
.inner-shadow-lg[data-v-05b576ad] {
  box-shadow: inset 8px 8px 32px #E2E8F0;
}
.inner-shadow-xl[data-v-05b576ad] {
  box-shadow: inset 16px 24px 48px #E2E8F0;
}
.alt-shadow-xs[data-v-05b576ad] {
  box-shadow: 2px 4px 12px -2px #F0EAF2;
}
.alt-shadow-sm-df[data-v-05b576ad] {
  box-shadow: 2px 4px 24px -4px #F0EAF2;
}
.alt-shadow-md[data-v-05b576ad] {
  box-shadow: 2px 4px 24px -4px #D1BDD7;
}
.alt-shadow-lg[data-v-05b576ad] {
  box-shadow: 4px 16px 32px -12px #F0EAF2, 2px 24px 48px -8px #F0EAF2;
}
.alt-shadow-xl[data-v-05b576ad] {
  box-shadow: 8px 24px 48px -12px #F0EAF2, 4px 32px 64px -16px #F0EAF2;
}
.focus-shadow-primary[data-v-05b576ad] {
  box-shadow: 0px 0px 0px 3px #BA9DC4;
}
.focus-shadow-error[data-v-05b576ad] {
  box-shadow: 0px 0px 0px 3px #EBA6B3;
}
.focus-shadow-success[data-v-05b576ad] {
  box-shadow: 0px 0px 0px 3px #98EBD7;
}
.focus-shadow-warning[data-v-05b576ad] {
  box-shadow: 0px 0px 0px 3px #F5C25F;
}
.focus-shadow-info[data-v-05b576ad] {
  box-shadow: 0px 0px 0px 3px #AEBFF0;
}
.border_stroke_sm_df[data-v-05b576ad] {
  border-width: 1px;
  border-style: solid;
}
.border_stroke_md[data-v-05b576ad] {
  border-width: 2px;
  border-style: solid;
}
.border_stroke_lg[data-v-05b576ad] {
  border-width: 4px;
  border-style: solid;
}
.border_rounded_none[data-v-05b576ad] {
  border-radius: 0;
}
.border_rounded_sm[data-v-05b576ad] {
  border-radius: 2px;
}
.border_rounded_md_df[data-v-05b576ad] {
  border-radius: 4px;
}
.border_rounded_lg[data-v-05b576ad] {
  border-radius: 8px;
}
.border_rounded_xl[data-v-05b576ad] {
  border-radius: 16px;
}
.border_rounded_2xl[data-v-05b576ad] {
  border-radius: 24px;
}
.border_rounded_pill[data-v-05b576ad] {
  border-radius: 103px;
}
.border_rounded_full[data-v-05b576ad] {
  border-radius: 50%;
}
.border_rounded_total[data-v-05b576ad] {
  border-radius: 100%;
}
.border_color_neutral_default[data-v-05b576ad] {
  border-color: #cbd5e1;
}
.border_color_neutral_200[data-v-05b576ad] {
  border-color: #e2e8f0;
}
.border_color_neutral_400[data-v-05b576ad] {
  border-color: #94a3b8;
}
.border_color_purple_default[data-v-05b576ad] {
  border-color: #692b7e;
}
.border_color_purple_100[data-v-05b576ad] {
  border-color: #d1bdd7;
}
.border_color_purple_500[data-v-05b576ad] {
  border-color: #692b7e;
}
.flex_vertical[data-v-05b576ad] {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
.flex_horizontal[data-v-05b576ad] {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.elipsis[data-v-05b576ad] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.company_type_badge[data-v-05b576ad] {
  display: flex;
  width: 100%;
}
.company_type_badge .iconn_svg[data-v-05b576ad] {
  margin-top: -3px;
  margin-right: 4px;
}
.company_type_badge span[data-v-05b576ad] {
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./../../_design_system/vue_v2/src/components/foundation/colors.scss","webpack://./../CompanyTypeBadge.vue","webpack://./../../_design_system/vue_v2/src/components/foundation/typography.scss","webpack://./../../_design_system/vue_v2/src/components/foundation/spacing.scss","webpack://./../../_design_system/vue_v2/src/components/foundation/sizing.scss","webpack://./../../_design_system/vue_v2/src/components/foundation/grids.scss","webpack://./../../_design_system/vue_v2/src/components/foundation/shadows.scss","webpack://./../../_design_system/vue_v2/src/components/foundation/border.scss","webpack://./../../_design_system/vue_v2/src/components/foundation/display.scss","webpack://./../../_design_system/vue_v2/src/components/atoms/CompanyTypeBadge.vue"],"names":[],"mappings":"AAAA,kEAAA;AACA,kEAAA;AACA,kEAAA;AACA,kEAAA;AACA,kEAAA;AACA,kEAAA;AACA,kEAAA;AAuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;ADuIE;EACE,cAAA;ACrIJ;AD0IE;EACE,cAAA;ACvIJ;ADyIE;EACE,cAAA;ACvIJ;ADyIE;EACE,cAAA;ACvIJ;ADyIE;EACE,cAAA;ACvIJ;ADyIE;EACE,cAAA;ACvIJ;ADyIE;EACE,cAAA;ACvIJ;ADyIE;EACE,cAAA;ACvIJ;ADyIE;EACE,cAAA;ACvIJ;ADyIE;EACE,cAAA;ACvIJ;ADyIE;EACE,cAAA;ACvIJ;AD4IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,4DAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD2IE;EACE,yBAAA;ACzIJ;AD8IE;EACE,qBAAA;AC3IJ;AD6IE;EACE,qBAAA;AC3IJ;AD6IE;EACE,qBAAA;AC3IJ;AD6IE;EACE,qBAAA;AC3IJ;AD6IE;EACE,8DAAA;AC3IJ;AD6IE;EACE,qBAAA;AC3IJ;AD6IE;EACE,qBAAA;AC3IJ;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AD0IF;ACvIA;EACE,yBAAA;AD0IF;ACvIA;EACE,0BAAA;AD0IF;ACvIA;EACE,yBAAA;AD0IF;ACvIA;EACE,0BAAA;AD0IF;AEteE;EACE,eAAA;AFyeJ;AEveE;EACE,eAAA;AFyeJ;AEveE;EACE,eAAA;AFyeJ;AEveE;EACE,gBAAA;AFyeJ;AEveE;EACE,gBAAA;AFyeJ;AEveE;EACE,gBAAA;AFyeJ;AEveE;EACE,gBAAA;AFyeJ;AEveE;EACE,gBAAA;AFyeJ;AEveE;EACE,gBAAA;AFyeJ;AEveE;EACE,gBAAA;AFyeJ;AEveE;EACE,gBAAA;AFyeJ;AEveE;EACE,gBAAA;AFyeJ;AEveE;EACE,iBAAA;AFyeJ;AEpeE;EACE,iBAAA;AFueJ;AEreE;EACE,iBAAA;AFueJ;AEreE;EACE,iBAAA;AFueJ;AEreE;EACE,kBAAA;AFueJ;AEreE;EACE,kBAAA;AFueJ;AEreE;EACE,kBAAA;AFueJ;AEreE;EACE,kBAAA;AFueJ;AEreE;EACE,kBAAA;AFueJ;AEreE;EACE,kBAAA;AFueJ;AEreE;EACE,kBAAA;AFueJ;AEreE;EACE,kBAAA;AFueJ;AEreE;EACE,kBAAA;AFueJ;AEreE;EACE,mBAAA;AFueJ;AEleE;EACE,kBAAA;AFqeJ;AEneE;EACE,kBAAA;AFqeJ;AEneE;EACE,kBAAA;AFqeJ;AEneE;EACE,mBAAA;AFqeJ;AEneE;EACE,mBAAA;AFqeJ;AEneE;EACE,mBAAA;AFqeJ;AEneE;EACE,mBAAA;AFqeJ;AEneE;EACE,mBAAA;AFqeJ;AEneE;EACE,mBAAA;AFqeJ;AEneE;EACE,mBAAA;AFqeJ;AEneE;EACE,mBAAA;AFqeJ;AEneE;EACE,mBAAA;AFqeJ;AEneE;EACE,oBAAA;AFqeJ;AEheE;EACE,gBAAA;AFmeJ;AEjeE;EACE,gBAAA;AFmeJ;AEjeE;EACE,gBAAA;AFmeJ;AEjeE;EACE,iBAAA;AFmeJ;AEjeE;EACE,iBAAA;AFmeJ;AEjeE;EACE,iBAAA;AFmeJ;AEjeE;EACE,iBAAA;AFmeJ;AEjeE;EACE,iBAAA;AFmeJ;AEjeE;EACE,iBAAA;AFmeJ;AEjeE;EACE,iBAAA;AFmeJ;AEjeE;EACE,iBAAA;AFmeJ;AEjeE;EACE,iBAAA;AFmeJ;AEjeE;EACE,kBAAA;AFmeJ;AE9dE;EACE,WAAA;AFieJ;AE/dE;EACE,WAAA;AFieJ;AE/dE;EACE,WAAA;AFieJ;AE/dE;EACE,YAAA;AFieJ;AE/dE;EACE,YAAA;AFieJ;AE/dE;EACE,YAAA;AFieJ;AE/dE;EACE,YAAA;AFieJ;AE/dE;EACE,YAAA;AFieJ;AE/dE;EACE,YAAA;AFieJ;AE/dE;EACE,YAAA;AFieJ;AE/dE;EACE,YAAA;AFieJ;AE/dE;EACE,YAAA;AFieJ;AE/dE;EACE,aAAA;AFieJ;AE5dE;EACE,gBAAA;AF+dJ;AE7dE;EACE,gBAAA;AF+dJ;AE7dE;EACE,gBAAA;AF+dJ;AE7dE;EACE,iBAAA;AF+dJ;AE7dE;EACE,iBAAA;AF+dJ;AE7dE;EACE,iBAAA;AF+dJ;AE7dE;EACE,iBAAA;AF+dJ;AE7dE;EACE,iBAAA;AF+dJ;AE7dE;EACE,iBAAA;AF+dJ;AE7dE;EACE,iBAAA;AF+dJ;AE7dE;EACE,iBAAA;AF+dJ;AE7dE;EACE,iBAAA;AF+dJ;AE7dE;EACE,kBAAA;AF+dJ;AE1dE;EACE,kBAAA;AF6dJ;AE3dE;EACE,kBAAA;AF6dJ;AE3dE;EACE,kBAAA;AF6dJ;AE3dE;EACE,mBAAA;AF6dJ;AE3dE;EACE,mBAAA;AF6dJ;AE3dE;EACE,mBAAA;AF6dJ;AE3dE;EACE,mBAAA;AF6dJ;AE3dE;EACE,mBAAA;AF6dJ;AE3dE;EACE,mBAAA;AF6dJ;AE3dE;EACE,mBAAA;AF6dJ;AE3dE;EACE,mBAAA;AF6dJ;AE3dE;EACE,mBAAA;AF6dJ;AE3dE;EACE,oBAAA;AF6dJ;AExdE;EACE,mBAAA;AF2dJ;AEzdE;EACE,mBAAA;AF2dJ;AEzdE;EACE,mBAAA;AF2dJ;AEzdE;EACE,oBAAA;AF2dJ;AEzdE;EACE,oBAAA;AF2dJ;AEzdE;EACE,oBAAA;AF2dJ;AEzdE;EACE,oBAAA;AF2dJ;AEzdE;EACE,oBAAA;AF2dJ;AEzdE;EACE,oBAAA;AF2dJ;AEzdE;EACE,oBAAA;AF2dJ;AEzdE;EACE,oBAAA;AF2dJ;AEzdE;EACE,oBAAA;AF2dJ;AEzdE;EACE,qBAAA;AF2dJ;AEtdE;EACE,iBAAA;AFydJ;AEvdE;EACE,iBAAA;AFydJ;AEvdE;EACE,iBAAA;AFydJ;AEvdE;EACE,kBAAA;AFydJ;AEvdE;EACE,kBAAA;AFydJ;AEvdE;EACE,kBAAA;AFydJ;AEvdE;EACE,kBAAA;AFydJ;AEvdE;EACE,kBAAA;AFydJ;AEvdE;EACE,kBAAA;AFydJ;AEvdE;EACE,kBAAA;AFydJ;AEvdE;EACE,kBAAA;AFydJ;AEvdE;EACE,kBAAA;AFydJ;AEvdE;EACE,mBAAA;AFydJ;AEpdE;EACE,YAAA;AFudJ;AErdE;EACE,YAAA;AFudJ;AErdE;EACE,YAAA;AFudJ;AErdE;EACE,aAAA;AFudJ;AErdE;EACE,aAAA;AFudJ;AErdE;EACE,aAAA;AFudJ;AErdE;EACE,aAAA;AFudJ;AErdE;EACE,aAAA;AFudJ;AErdE;EACE,aAAA;AFudJ;AErdE;EACE,aAAA;AFudJ;AErdE;EACE,aAAA;AFudJ;AErdE;EACE,aAAA;AFudJ;AErdE;EACE,cAAA;AFudJ;AGt3BE;EACE,UAAA;AHy3BJ;AGv3BE;EACE,WAAA;AHy3BJ;AGv3BE;EACE,WAAA;AHy3BJ;AGv3BE;EACE,WAAA;AHy3BJ;AGv3BE;EACE,WAAA;AHy3BJ;AGv3BE;EACE,WAAA;AHy3BJ;AGv3BE;EACE,WAAA;AHy3BJ;AGv3BE;EACE,WAAA;AHy3BJ;AGv3BE;EACE,WAAA;AHy3BJ;AGv3BE;EACE,WAAA;AHy3BJ;AGv3BE;EACE,YAAA;AHy3BJ;AGv3BE;EACE,qBAAA;AHy3BJ;AGv3BE;EACE,sBAAA;AHy3BJ;AGv3BE;EACE,sBAAA;AHy3BJ;AGv3BE;EACE,sBAAA;AHy3BJ;AGv3BE;EACE,sBAAA;AHy3BJ;AGv3BE;EACE,sBAAA;AHy3BJ;AGv3BE;EACE,sBAAA;AHy3BJ;AGv3BE;EACE,sBAAA;AHy3BJ;AGv3BE;EACE,sBAAA;AHy3BJ;AGv3BE;EACE,sBAAA;AHy3BJ;AGv3BE;EACE,uBAAA;AHy3BJ;AGp3BE;EACE,WAAA;AHu3BJ;AGr3BE;EACE,YAAA;AHu3BJ;AGr3BE;EACE,YAAA;AHu3BJ;AGr3BE;EACE,YAAA;AHu3BJ;AGr3BE;EACE,YAAA;AHu3BJ;AGr3BE;EACE,YAAA;AHu3BJ;AGr3BE;EACE,YAAA;AHu3BJ;AGr3BE;EACE,YAAA;AHu3BJ;AGr3BE;EACE,YAAA;AHu3BJ;AGr3BE;EACE,YAAA;AHu3BJ;AGr3BE;EACE,aAAA;AHu3BJ;AGr3BE;EACE,sBAAA;AHu3BJ;AGr3BE;EACE,uBAAA;AHu3BJ;AGr3BE;EACE,uBAAA;AHu3BJ;AGr3BE;EACE,uBAAA;AHu3BJ;AGr3BE;EACE,uBAAA;AHu3BJ;AGr3BE;EACE,uBAAA;AHu3BJ;AGr3BE;EACE,uBAAA;AHu3BJ;AGr3BE;EACE,uBAAA;AHu3BJ;AGr3BE;EACE,uBAAA;AHu3BJ;AGr3BE;EACE,uBAAA;AHu3BJ;AGr3BE;EACE,wBAAA;AHu3BJ;AI36BE;EAEI,aAAA;EAAA,YAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,mBAAA;AJm7BN;AIr7BE;EAEI,aAAA;EAAA,YAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,mBAAA;AJ67BN;AI/7BE;EAEI,aAAA;EAAA,aAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,mBAAA;AJu8BN;AIz8BE;EAEI,aAAA;EAAA,aAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,mBAAA;AJk9BN;AIp9BE;EAEI,aAAA;EAAA,YAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,mBAAA;AJ49BN;AI99BE;EAEI,aAAA;EAAA,YAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,mBAAA;AJs+BN;AIx+BE;EAEI,aAAA;EAAA,aAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,mBAAA;AJg/BN;AIl/BE;EAEI,aAAA;EAAA,aAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,mBAAA;AJ0/BN;AK9kCA;EACE,qCAAA;ALilCF;AK9kCA;EACE,qCAAA;ALilCF;AK9kCA;EACE,qCAAA;ALilCF;AK9kCA;EACE,8DAAA;ALilCF;AK9kCA;EACE,8DAAA;ALilCF;AK9kCA;EACE,0CAAA;ALilCF;AK9kCA;EACE,sCAAA;ALilCF;AK9kCA;EACE,sCAAA;ALilCF;AK9kCA;EACE,sCAAA;ALilCF;AK9kCA;EACE,wCAAA;ALilCF;AK9kCA;EACE,qCAAA;ALilCF;AK9kCA;EACE,qCAAA;ALilCF;AK9kCA;EACE,qCAAA;ALilCF;AK9kCA;EACE,mEAAA;ALilCF;AK9kCA;EACE,oEAAA;ALilCF;AK9kCA;EACE,mCAAA;ALilCF;AK9kCA;EACE,mCAAA;ALilCF;AK9kCA;EACE,mCAAA;ALilCF;AK9kCA;EACE,mCAAA;ALilCF;AK9kCA;EACE,mCAAA;ALilCF;AM9pCA;EACE,iBAAA;EACA,mBAAA;ANiqCF;AM9pCA;EACE,iBAAA;EACA,mBAAA;ANiqCF;AM9pCA;EACE,iBAAA;EACA,mBAAA;ANiqCF;AM9pCA;EACE,gBAAA;ANiqCF;AM9pCA;EACE,kBAAA;ANiqCF;AM9pCA;EACE,kBAAA;ANiqCF;AM9pCA;EACE,kBAAA;ANiqCF;AM9pCA;EACE,mBAAA;ANiqCF;AM9pCA;EACE,mBAAA;ANiqCF;AM9pCA;EACE,oBAAA;ANiqCF;AM9pCA;EACE,kBAAA;ANiqCF;AM9pCA;EACE,mBAAA;ANiqCF;AM9pCA;EACE,qBAAA;ANiqCF;AM9pCA;EACE,qBAAA;ANiqCF;AM9pCA;EACE,qBAAA;ANiqCF;AM9pCA;EACE,qBAAA;ANiqCF;AM9pCA;EACE,qBAAA;ANiqCF;AM9pCA;EACE,qBAAA;ANiqCF;AOzuCA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AP4uCF;AOzuCA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AP4uCF;AOzuCA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AP4uCF;AQxvCA;EACE,aAAA;EACA,WAAA;AR2vCF;AQzvCE;EACE,gBAAA;EACA,iBAAA;AR2vCJ;AQxvCE;EACE,yBAAA;AR0vCJ","sourcesContent":["/* ************************************************************* */\n/* ************************************************************* */\n/* ** THIS FILE WAS AUTO GENERATED BY utils/figmaExtractor.js ** */\n/* **                                                         ** */\n/* ** DO NOT ALTER IT MANUALLY - YOUR CHANGES WILL BE LOST!!! ** */\n/* ************************************************************* */\n/* ************************************************************* */\n$primary: (\n  \"purple-900\": #2c1235,\n  \"purple-800\": #3a1845,\n  \"purple-700\": #4b1f59,\n  \"purple-600\": #602773,\n  \"purple-500\": #692b7e,\n  \"purple-400\": #875598,\n  \"purple-300\": #9b71a9,\n  \"purple-200\": #ba9dc4,\n  \"purple-100\": #d1bdd7,\n  \"purple-50\": #f0eaf2,\n);\n$secondary: (\n  \"blue-900\": #21305e,\n  \"blue-800\": #2b3f7b,\n  \"blue-700\": #37529e,\n  \"blue-600\": #4769cb,\n  \"blue-500\": #4e73df,\n  \"blue-400\": #718fe5,\n  \"blue-300\": #88a1ea,\n  \"blue-200\": #aebff0,\n  \"blue-100\": #c8d4f5,\n  \"blue-50\": #f5f8ff,\n);\n$neutral: (\n  \"neutral-900\": #0f172a,\n  \"neutral-800\": #1e293b,\n  \"neutral-700\": #334155,\n  \"neutral-600\": #475569,\n  \"neutral-500\": #64748b,\n  \"neutral-400\": #94a3b8,\n  \"neutral-300\": #cbd5e1,\n  \"neutral-200\": #e2e8f0,\n  \"neutral-100\": #f1f5f9,\n  \"neutral-50\": #f8fafc,\n);\n$grey_scale: (\n  \"grey-900\": #42444a,\n  \"grey-800\": #565a60,\n  \"grey-700\": #6f747c,\n  \"grey-600\": #8e949f,\n  \"grey-500\": #9ca3af,\n  \"grey-400\": #b0b5bf,\n  \"grey-300\": #bdc1c9,\n  \"grey-200\": #d1d5da,\n  \"grey-100\": #e0e2e6,\n  \"grey-50\": #f5f6f7,\n);\n$basic: (\n  \"black-100\": #262626,\n  \"black-50\": #080d17,\n  \"black\": #060910,\n  \"white\": #ffffff,\n  \"white-50\": #fdfdfd,\n);\n$success: (\n  \"green-900\": #0d5947,\n  \"green-800\": #11755d,\n  \"green-700\": #169778,\n  \"green-600\": #1cc19a,\n  \"green-500\": #1fd4a9,\n  \"green-400\": #4cddba,\n  \"green-300\": #69e2c5,\n  \"green-200\": #98ebd7,\n  \"green-100\": #baf2e4,\n  \"green-50\": #f6fffc,\n);\n$warning: (\n  \"orange-900\": #654507,\n  \"orange-800\": #845a09,\n  \"orange-700\": #aa740b,\n  \"orange-600\": #da950f,\n  \"orange-500\": #f0a410,\n  \"orange-400\": #f3b640,\n  \"orange-300\": #f5c25f,\n  \"orange-200\": #f8d591,\n  \"orange-100\": #fae3b5,\n  \"orange-50\": #FFFAF2,\n);\n$error: (\n  \"red-900\": #742231,\n  \"red-800\": #742231,\n  \"red-700\": #962b3f,\n  \"red-600\": #c03851,\n  \"red-500\": #d33d59,\n  \"red-400\": #dc647a,\n  \"red-300\": #e27d90,\n  \"red-200\": #eba6b3,\n  \"red-100\": #f1c3cc,\n  \"red-50\": #fff5f6,\n);\n$groups_dark: (\n  \"green\": #11755D,\n  \"yellow\": #FFBE0B,\n  \"purple\": #724DCA,\n  \"blue\": #4E73DF,\n  \"red\": #AC3E55,\n  \"pink\": #EA3989,\n  \"orange\": #ED6E40,\n  \"mint\": #08AA80,\n);\n$groups_bright: (\n  \"green\": #B0DC00,\n  \"yellow\": #FFDE75,\n  \"purple\": #9960d5,\n  \"blue\": #80CAFA,\n  \"red\": #D1505F,\n  \"pink\": #EC66C0,\n  \"orange\": #FFA280,\n  \"mint\": #06D6A0,\n);\n$user_type: (\n  \"allocator\": #4E73DF,\n  \"manager\": #692B7E,\n  \"service_provider\": #475569,\n  \"media_press\": #07829D,\n  \"guest\": #94A3B8,\n  \"speaker\": #40ACD7,\n  \"sponsor\": #7968D7,\n  \"iconnections\": #B45ED1,\n  \"vendor\": #88A1EA,\n  \"staff\": #9B71A9,\n);\n$gradients: (\n  \"positive\": linear-gradient(45deg, map-get($success, \"green-500\") 0%, map-get($success, \"green-600\") 100%),\n  \"positive_dark\": linear-gradient(45deg, map-get($success, \"green-600\") 0%, map-get($success, \"green-700\") 100%),\n  \"purple_spark\": linear-gradient(45deg, map-get($primary, \"purple-300\") 0%, map-get($primary, \"purple-500\") 100%),\n  \"dark_purple_spark\": linear-gradient(45deg, map-get($primary, \"purple-400\") 0%, map-get($primary, \"purple-800\") 100%),\n  \"additional\": linear-gradient(45deg, map-get($secondary, \"blue-500\") 0%, map-get($primary, \"purple-500\") 100%),\n  \"alternative\": linear-gradient(45deg, map-get($success, \"green-500\") 0%, map-get($secondary, \"blue-400\") 50%, map-get($primary, \"purple-400\") 100%),\n  \"alternative_hover\": linear-gradient(45deg, map-get($success, \"green-600\") 0%, map-get($secondary, \"blue-500\") 50%, map-get($primary, \"purple-500\") 100%),\n);\n\n.typography {\n  &_default {\n    color: map-get($neutral, \"neutral-700\");\n  }\n  &_dark {\n    color: map-get($neutral, \"neutral-900\");\n  }\n  &_light {\n    color: map-get($neutral, \"neutral-500\");\n  }\n  &_disabled {\n    color: map-get($grey_scale, \"grey-700\");\n  }\n  &_success {\n    color: map-get($success, \"green-800\");\n  }\n  &_warning {\n    color: map-get($warning, \"orange-700\");\n  }\n  &_error {\n    color: map-get($error, \"red-600\");\n  }\n  &_white {\n    color: map-get($basic, \"white\");\n  }\n  &_info {\n    color: map-get($secondary, \"blue-600\");\n  }\n  &_primary {\n    color: map-get($primary, \"purple-500\");\n  }\n  &_black {\n    color: map-get($basic, \"black-100\");\n  }\n  &_grey {\n    color: map-get($grey_scale, \"grey-700\")\n  }\n}\n\n.user_type {\n  &_allocator {\n    color: map-get($user_type, \"allocator\");\n  }\n  &_manager {\n    color: map-get($user_type, \"manager\");\n  }\n  &_service_provider {\n    color: map-get($user_type, \"service_provider\");\n  }\n  &_media_press {\n    color: map-get($user_type, \"media_press\");\n  }\n  &_guest {\n    color: map-get($user_type, \"guest\");\n  }\n  &_speaker {\n    color: map-get($user_type, \"speaker\");\n  }\n  &_sponsor {\n    color: map-get($user_type, \"sponsor\");\n  }\n  &_iconnections {\n    color: map-get($user_type, \"iconnections\");\n  }\n  &_vendor {\n    color: map-get($user_type, \"vendor\");\n  }\n  &_staff {\n    color: map-get($user_type, \"staff\");\n  }\n}\n\n.background {\n  &_neutral_default {\n    background-color: map-get($neutral, \"neutral-50\");\n  }\n  &_neutral_secondary {\n    background-color: map-get($neutral, \"neutral-100\");\n  }\n  &_grayscale {\n    background-color: map-get($grey_scale, \"grey-50\");\n  }\n  &_neutral_white {\n    background-color: map-get($basic, \"white\");\n  }\n  &_primary_brand_color {\n    background-color: map-get($primary, \"purple-50\");\n  }\n  &_info {\n    background-color: map-get($secondary, \"blue-500\");\n  }\n  &_info_subtle {\n    background-color: map-get($secondary, \"blue-50\");\n  }\n  &_positive_subtle {\n    background-color: map-get($success, \"green-50\");\n  }\n  &_positive {\n    background: map-get($gradients, \"positive_dark\");\n  }\n  &_negative {\n    background-color: map-get($error, \"red-500\");\n  }\n  &_negative_subtle {\n    background-color: map-get($error, \"red-50\");\n  }\n  &_warning {\n    background-color: map-get($warning, \"orange-500\");\n  }\n  &_warning_subtle {\n    background-color: map-get($warning, \"orange-50\");\n  }\n}\n\n.border {\n  &_neutral_default {\n    border-color: map-get($neutral, \"neutral-300\");\n  }\n  &_neutral_secondary {\n    border-color: map-get($neutral, \"neutral-400\");\n  }\n  &_info {\n    border-color: map-get($secondary, \"blue-500\");\n  }\n  &_negative {\n    border-color: map-get($error, \"red-500\");\n  }\n  &_positive {\n    border-color: map-get($gradients, \"positive\");\n  }\n  &_success {\n    border-color: map-get($success, \"green-700\");\n  }\n  &_warning {\n    border-color: map-get($warning, \"orange-500\");\n  }\n}","/* ************************************************************* */\n/* ************************************************************* */\n/* ** THIS FILE WAS AUTO GENERATED BY utils/figmaExtractor.js ** */\n/* **                                                         ** */\n/* ** DO NOT ALTER IT MANUALLY - YOUR CHANGES WILL BE LOST!!! ** */\n/* ************************************************************* */\n/* ************************************************************* */\n.typography_default {\n  color: #334155;\n}\n.typography_dark {\n  color: #0f172a;\n}\n.typography_light {\n  color: #64748b;\n}\n.typography_disabled {\n  color: #6f747c;\n}\n.typography_success {\n  color: #11755d;\n}\n.typography_warning {\n  color: #aa740b;\n}\n.typography_error {\n  color: #c03851;\n}\n.typography_white {\n  color: #ffffff;\n}\n.typography_info {\n  color: #4769cb;\n}\n.typography_primary {\n  color: #692b7e;\n}\n.typography_black {\n  color: #262626;\n}\n.typography_grey {\n  color: #6f747c;\n}\n\n.user_type_allocator {\n  color: #4E73DF;\n}\n.user_type_manager {\n  color: #692B7E;\n}\n.user_type_service_provider {\n  color: #475569;\n}\n.user_type_media_press {\n  color: #07829D;\n}\n.user_type_guest {\n  color: #94A3B8;\n}\n.user_type_speaker {\n  color: #40ACD7;\n}\n.user_type_sponsor {\n  color: #7968D7;\n}\n.user_type_iconnections {\n  color: #B45ED1;\n}\n.user_type_vendor {\n  color: #88A1EA;\n}\n.user_type_staff {\n  color: #9B71A9;\n}\n\n.background_neutral_default {\n  background-color: #f8fafc;\n}\n.background_neutral_secondary {\n  background-color: #f1f5f9;\n}\n.background_grayscale {\n  background-color: #f5f6f7;\n}\n.background_neutral_white {\n  background-color: #ffffff;\n}\n.background_primary_brand_color {\n  background-color: #f0eaf2;\n}\n.background_info {\n  background-color: #4e73df;\n}\n.background_info_subtle {\n  background-color: #f5f8ff;\n}\n.background_positive_subtle {\n  background-color: #f6fffc;\n}\n.background_positive {\n  background: linear-gradient(45deg, #1cc19a 0%, #169778 100%);\n}\n.background_negative {\n  background-color: #d33d59;\n}\n.background_negative_subtle {\n  background-color: #fff5f6;\n}\n.background_warning {\n  background-color: #f0a410;\n}\n.background_warning_subtle {\n  background-color: #FFFAF2;\n}\n\n.border_neutral_default {\n  border-color: #cbd5e1;\n}\n.border_neutral_secondary {\n  border-color: #94a3b8;\n}\n.border_info {\n  border-color: #4e73df;\n}\n.border_negative {\n  border-color: #d33d59;\n}\n.border_positive {\n  border-color: linear-gradient(45deg, #1fd4a9 0%, #1cc19a 100%);\n}\n.border_success {\n  border-color: #169778;\n}\n.border_warning {\n  border-color: #f0a410;\n}\n\n.bold-headline-h1-xl {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 40px;\n  line-height: 140%;\n}\n\n.bold-headline-h2-lg {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 140%;\n}\n\n.bold-headline-h3-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 140%;\n}\n\n.bold-headline-h4-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 140%;\n}\n\n.medium-headline-h1-xl {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 40px;\n  line-height: 140%;\n}\n\n.medium-headline-h2-lg {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 32px;\n  line-height: 140%;\n}\n\n.medium-headline-h3-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 140%;\n}\n\n.medium-headline-h4-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 140%;\n}\n\n.regular-headline-h1-xl {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 40px;\n  line-height: 140%;\n}\n\n.regular-headline-h2-lg {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 32px;\n  line-height: 140%;\n}\n\n.regular-headline-h3-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 140%;\n}\n\n.regular-headline-h4-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 140%;\n}\n\n.bold-subtitle-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 140%;\n}\n\n.bold-subtitle-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 140%;\n}\n\n.medium-subtitle-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 135%;\n}\n\n.medium-subtitle-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 140%;\n}\n\n.regular-subtitle-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 140%;\n}\n\n.regular-subtitle-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 140%;\n}\n\n.bold-body-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.bold-body-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.medium-body-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.medium-body-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.regular-body-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.regular-body-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.bold-caption-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 140%;\n}\n\n.bold-caption-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 140%;\n}\n\n.medium-caption-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 140%;\n}\n\n.medium-caption-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 10px;\n  line-height: 140%;\n}\n\n.regular-caption-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 140%;\n}\n\n.regular-caption-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 140%;\n}\n\n.bold-overline-xl {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.bold-overline-lg {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.bold-overline-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n.bold-overline-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 150%;\n}\n\n.medium-overline-xl {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.medium-overline-lg {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.medium-overline-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n.medium-overline-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 10px;\n  line-height: 150%;\n}\n\n.regular-overline-xl {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.regular-overline-lg {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.regular-overline-md {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n.regular-overline-sm {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 150%;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\n.lowercase {\n  text-transform: lowercase;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.margin-top_3xs {\n  margin-top: 2px;\n}\n.margin-top_2xs {\n  margin-top: 4px;\n}\n.margin-top_xs-df {\n  margin-top: 8px;\n}\n.margin-top_sm {\n  margin-top: 16px;\n}\n.margin-top_md {\n  margin-top: 24px;\n}\n.margin-top_lg {\n  margin-top: 32px;\n}\n.margin-top_xl {\n  margin-top: 40px;\n}\n.margin-top_2xl {\n  margin-top: 48px;\n}\n.margin-top_3xl {\n  margin-top: 56px;\n}\n.margin-top_4xl {\n  margin-top: 64px;\n}\n.margin-top_5xl {\n  margin-top: 72px;\n}\n.margin-top_6xl {\n  margin-top: 80px;\n}\n.margin-top_7xl {\n  margin-top: 128px;\n}\n\n.margin-right_3xs {\n  margin-right: 2px;\n}\n.margin-right_2xs {\n  margin-right: 4px;\n}\n.margin-right_xs-df {\n  margin-right: 8px;\n}\n.margin-right_sm {\n  margin-right: 16px;\n}\n.margin-right_md {\n  margin-right: 24px;\n}\n.margin-right_lg {\n  margin-right: 32px;\n}\n.margin-right_xl {\n  margin-right: 40px;\n}\n.margin-right_2xl {\n  margin-right: 48px;\n}\n.margin-right_3xl {\n  margin-right: 56px;\n}\n.margin-right_4xl {\n  margin-right: 64px;\n}\n.margin-right_5xl {\n  margin-right: 72px;\n}\n.margin-right_6xl {\n  margin-right: 80px;\n}\n.margin-right_7xl {\n  margin-right: 128px;\n}\n\n.margin-bottom_3xs {\n  margin-bottom: 2px;\n}\n.margin-bottom_2xs {\n  margin-bottom: 4px;\n}\n.margin-bottom_xs-df {\n  margin-bottom: 8px;\n}\n.margin-bottom_sm {\n  margin-bottom: 16px;\n}\n.margin-bottom_md {\n  margin-bottom: 24px;\n}\n.margin-bottom_lg {\n  margin-bottom: 32px;\n}\n.margin-bottom_xl {\n  margin-bottom: 40px;\n}\n.margin-bottom_2xl {\n  margin-bottom: 48px;\n}\n.margin-bottom_3xl {\n  margin-bottom: 56px;\n}\n.margin-bottom_4xl {\n  margin-bottom: 64px;\n}\n.margin-bottom_5xl {\n  margin-bottom: 72px;\n}\n.margin-bottom_6xl {\n  margin-bottom: 80px;\n}\n.margin-bottom_7xl {\n  margin-bottom: 128px;\n}\n\n.margin-left_3xs {\n  margin-left: 2px;\n}\n.margin-left_2xs {\n  margin-left: 4px;\n}\n.margin-left_xs-df {\n  margin-left: 8px;\n}\n.margin-left_sm {\n  margin-left: 16px;\n}\n.margin-left_md {\n  margin-left: 24px;\n}\n.margin-left_lg {\n  margin-left: 32px;\n}\n.margin-left_xl {\n  margin-left: 40px;\n}\n.margin-left_2xl {\n  margin-left: 48px;\n}\n.margin-left_3xl {\n  margin-left: 56px;\n}\n.margin-left_4xl {\n  margin-left: 64px;\n}\n.margin-left_5xl {\n  margin-left: 72px;\n}\n.margin-left_6xl {\n  margin-left: 80px;\n}\n.margin-left_7xl {\n  margin-left: 128px;\n}\n\n.margin_3xs {\n  margin: 2px;\n}\n.margin_2xs {\n  margin: 4px;\n}\n.margin_xs-df {\n  margin: 8px;\n}\n.margin_sm {\n  margin: 16px;\n}\n.margin_md {\n  margin: 24px;\n}\n.margin_lg {\n  margin: 32px;\n}\n.margin_xl {\n  margin: 40px;\n}\n.margin_2xl {\n  margin: 48px;\n}\n.margin_3xl {\n  margin: 56px;\n}\n.margin_4xl {\n  margin: 64px;\n}\n.margin_5xl {\n  margin: 72px;\n}\n.margin_6xl {\n  margin: 80px;\n}\n.margin_7xl {\n  margin: 128px;\n}\n\n.padding-top_3xs {\n  padding-top: 2px;\n}\n.padding-top_2xs {\n  padding-top: 4px;\n}\n.padding-top_xs-df {\n  padding-top: 8px;\n}\n.padding-top_sm {\n  padding-top: 16px;\n}\n.padding-top_md {\n  padding-top: 24px;\n}\n.padding-top_lg {\n  padding-top: 32px;\n}\n.padding-top_xl {\n  padding-top: 40px;\n}\n.padding-top_2xl {\n  padding-top: 48px;\n}\n.padding-top_3xl {\n  padding-top: 56px;\n}\n.padding-top_4xl {\n  padding-top: 64px;\n}\n.padding-top_5xl {\n  padding-top: 72px;\n}\n.padding-top_6xl {\n  padding-top: 80px;\n}\n.padding-top_7xl {\n  padding-top: 128px;\n}\n\n.padding-right_3xs {\n  padding-right: 2px;\n}\n.padding-right_2xs {\n  padding-right: 4px;\n}\n.padding-right_xs-df {\n  padding-right: 8px;\n}\n.padding-right_sm {\n  padding-right: 16px;\n}\n.padding-right_md {\n  padding-right: 24px;\n}\n.padding-right_lg {\n  padding-right: 32px;\n}\n.padding-right_xl {\n  padding-right: 40px;\n}\n.padding-right_2xl {\n  padding-right: 48px;\n}\n.padding-right_3xl {\n  padding-right: 56px;\n}\n.padding-right_4xl {\n  padding-right: 64px;\n}\n.padding-right_5xl {\n  padding-right: 72px;\n}\n.padding-right_6xl {\n  padding-right: 80px;\n}\n.padding-right_7xl {\n  padding-right: 128px;\n}\n\n.padding-bottom_3xs {\n  padding-bottom: 2px;\n}\n.padding-bottom_2xs {\n  padding-bottom: 4px;\n}\n.padding-bottom_xs-df {\n  padding-bottom: 8px;\n}\n.padding-bottom_sm {\n  padding-bottom: 16px;\n}\n.padding-bottom_md {\n  padding-bottom: 24px;\n}\n.padding-bottom_lg {\n  padding-bottom: 32px;\n}\n.padding-bottom_xl {\n  padding-bottom: 40px;\n}\n.padding-bottom_2xl {\n  padding-bottom: 48px;\n}\n.padding-bottom_3xl {\n  padding-bottom: 56px;\n}\n.padding-bottom_4xl {\n  padding-bottom: 64px;\n}\n.padding-bottom_5xl {\n  padding-bottom: 72px;\n}\n.padding-bottom_6xl {\n  padding-bottom: 80px;\n}\n.padding-bottom_7xl {\n  padding-bottom: 128px;\n}\n\n.padding-left_3xs {\n  padding-left: 2px;\n}\n.padding-left_2xs {\n  padding-left: 4px;\n}\n.padding-left_xs-df {\n  padding-left: 8px;\n}\n.padding-left_sm {\n  padding-left: 16px;\n}\n.padding-left_md {\n  padding-left: 24px;\n}\n.padding-left_lg {\n  padding-left: 32px;\n}\n.padding-left_xl {\n  padding-left: 40px;\n}\n.padding-left_2xl {\n  padding-left: 48px;\n}\n.padding-left_3xl {\n  padding-left: 56px;\n}\n.padding-left_4xl {\n  padding-left: 64px;\n}\n.padding-left_5xl {\n  padding-left: 72px;\n}\n.padding-left_6xl {\n  padding-left: 80px;\n}\n.padding-left_7xl {\n  padding-left: 128px;\n}\n\n.padding_3xs {\n  padding: 2px;\n}\n.padding_2xs {\n  padding: 4px;\n}\n.padding_xs-df {\n  padding: 8px;\n}\n.padding_sm {\n  padding: 16px;\n}\n.padding_md {\n  padding: 24px;\n}\n.padding_lg {\n  padding: 32px;\n}\n.padding_xl {\n  padding: 40px;\n}\n.padding_2xl {\n  padding: 48px;\n}\n.padding_3xl {\n  padding: 56px;\n}\n.padding_4xl {\n  padding: 64px;\n}\n.padding_5xl {\n  padding: 72px;\n}\n.padding_6xl {\n  padding: 80px;\n}\n.padding_7xl {\n  padding: 128px;\n}\n\n.width_xs-df {\n  width: 8px;\n}\n.width_sm {\n  width: 16px;\n}\n.width_md {\n  width: 24px;\n}\n.width_lg {\n  width: 32px;\n}\n.width_xl {\n  width: 40px;\n}\n.width_2xl {\n  width: 48px;\n}\n.width_3xl {\n  width: 56px;\n}\n.width_4xl {\n  width: 64px;\n}\n.width_5xl {\n  width: 72px;\n}\n.width_6xl {\n  width: 80px;\n}\n.width_7xl {\n  width: 128px;\n}\n.width_xs-df-important {\n  width: 8px !important;\n}\n.width_sm-important {\n  width: 16px !important;\n}\n.width_md-important {\n  width: 24px !important;\n}\n.width_lg-important {\n  width: 32px !important;\n}\n.width_xl-important {\n  width: 40px !important;\n}\n.width_2xl-important {\n  width: 48px !important;\n}\n.width_3xl-important {\n  width: 56px !important;\n}\n.width_4xl-important {\n  width: 64px !important;\n}\n.width_5xl-important {\n  width: 72px !important;\n}\n.width_6xl-important {\n  width: 80px !important;\n}\n.width_7xl-important {\n  width: 128px !important;\n}\n\n.height_xs-df {\n  height: 8px;\n}\n.height_sm {\n  height: 16px;\n}\n.height_md {\n  height: 24px;\n}\n.height_lg {\n  height: 32px;\n}\n.height_xl {\n  height: 40px;\n}\n.height_2xl {\n  height: 48px;\n}\n.height_3xl {\n  height: 56px;\n}\n.height_4xl {\n  height: 64px;\n}\n.height_5xl {\n  height: 72px;\n}\n.height_6xl {\n  height: 80px;\n}\n.height_7xl {\n  height: 128px;\n}\n.height_xs-df-important {\n  height: 8px !important;\n}\n.height_sm-important {\n  height: 16px !important;\n}\n.height_md-important {\n  height: 24px !important;\n}\n.height_lg-important {\n  height: 32px !important;\n}\n.height_xl-important {\n  height: 40px !important;\n}\n.height_2xl-important {\n  height: 48px !important;\n}\n.height_3xl-important {\n  height: 56px !important;\n}\n.height_4xl-important {\n  height: 64px !important;\n}\n.height_5xl-important {\n  height: 72px !important;\n}\n.height_6xl-important {\n  height: 80px !important;\n}\n.height_7xl-important {\n  height: 128px !important;\n}\n\n.grid-grid-600 {\n  height: 960px;\n  width: 600px;\n  padding-top: 64px;\n  padding-left: 0px;\n  border-radius: 8px;\n  border: 1px solid #E5E5E5;\n  background: #F4F6FC;\n}\n\n.grid-grid-900 {\n  height: 960px;\n  width: 900px;\n  padding-top: 64px;\n  padding-left: 0px;\n  border-radius: 8px;\n  border: 1px solid #E5E5E5;\n  background: #F4F6FC;\n}\n\n.grid-grid-1240 {\n  height: 960px;\n  width: 1240px;\n  padding-top: 64px;\n  padding-left: 0px;\n  border-radius: 8px;\n  border: 1px solid #E5E5E5;\n  background: #F4F6FC;\n}\n\n.grid-grid-1440 {\n  height: 960px;\n  width: 1440px;\n  padding-top: 64px;\n  padding-left: 0px;\n  padding-color: white;\n  border-radius: 8px;\n  border: 1px solid #E5E5E5;\n  background: #F4F6FC;\n}\n\n.grid-grid-600-sidebar {\n  height: 960px;\n  width: 600px;\n  padding-top: 64px;\n  padding-left: 80px;\n  border-radius: 8px;\n  border: 1px solid #E5E5E5;\n  background: #F4F6FC;\n}\n\n.grid-grid-900-sidebar {\n  height: 960px;\n  width: 900px;\n  padding-top: 64px;\n  padding-left: 80px;\n  border-radius: 8px;\n  border: 1px solid #E5E5E5;\n  background: #F4F6FC;\n}\n\n.grid-grid-1240-sidebar {\n  height: 960px;\n  width: 1240px;\n  padding-top: 64px;\n  padding-left: 296px;\n  border-radius: 8px;\n  border: 1px solid #E5E5E5;\n  background: #F4F6FC;\n}\n\n.grid-grid-1440-sidebar {\n  height: 960px;\n  width: 1440px;\n  padding-top: 64px;\n  padding-left: 296px;\n  border-radius: 8px;\n  border: 1px solid #E5E5E5;\n  background: #F4F6FC;\n}\n\n.gray-shadow-xs {\n  box-shadow: 2px 4px 12px -2px #F1F5F9;\n}\n\n.gray-shadow-sm-df {\n  box-shadow: 2px 4px 24px -4px #E2E8F0;\n}\n\n.gray-shadow-md {\n  box-shadow: 2px 4px 24px -4px #E2E8F0;\n}\n\n.gray-shadow-lg {\n  box-shadow: 4px 16px 32px -12px #F1F5F9, 2px 24px 48px #F1F5F9;\n}\n\n.gray-shadow-xl {\n  box-shadow: 8px 24px 48px -16px #F1F5F9, 4px 32px 64px #F1F5F9;\n}\n\n.inner-shadow-xs-df {\n  box-shadow: inset 0px 2px 8px -2px #E2E8F0;\n}\n\n.inner-shadow-sm {\n  box-shadow: inset 2px 4px 16px #E2E8F0;\n}\n\n.inner-shadow-md {\n  box-shadow: inset 4px 8px 24px #E2E8F0;\n}\n\n.inner-shadow-lg {\n  box-shadow: inset 8px 8px 32px #E2E8F0;\n}\n\n.inner-shadow-xl {\n  box-shadow: inset 16px 24px 48px #E2E8F0;\n}\n\n.alt-shadow-xs {\n  box-shadow: 2px 4px 12px -2px #F0EAF2;\n}\n\n.alt-shadow-sm-df {\n  box-shadow: 2px 4px 24px -4px #F0EAF2;\n}\n\n.alt-shadow-md {\n  box-shadow: 2px 4px 24px -4px #D1BDD7;\n}\n\n.alt-shadow-lg {\n  box-shadow: 4px 16px 32px -12px #F0EAF2, 2px 24px 48px -8px #F0EAF2;\n}\n\n.alt-shadow-xl {\n  box-shadow: 8px 24px 48px -12px #F0EAF2, 4px 32px 64px -16px #F0EAF2;\n}\n\n.focus-shadow-primary {\n  box-shadow: 0px 0px 0px 3px #BA9DC4;\n}\n\n.focus-shadow-error {\n  box-shadow: 0px 0px 0px 3px #EBA6B3;\n}\n\n.focus-shadow-success {\n  box-shadow: 0px 0px 0px 3px #98EBD7;\n}\n\n.focus-shadow-warning {\n  box-shadow: 0px 0px 0px 3px #F5C25F;\n}\n\n.focus-shadow-info {\n  box-shadow: 0px 0px 0px 3px #AEBFF0;\n}\n\n.border_stroke_sm_df {\n  border-width: 1px;\n  border-style: solid;\n}\n\n.border_stroke_md {\n  border-width: 2px;\n  border-style: solid;\n}\n\n.border_stroke_lg {\n  border-width: 4px;\n  border-style: solid;\n}\n\n.border_rounded_none {\n  border-radius: 0;\n}\n\n.border_rounded_sm {\n  border-radius: 2px;\n}\n\n.border_rounded_md_df {\n  border-radius: 4px;\n}\n\n.border_rounded_lg {\n  border-radius: 8px;\n}\n\n.border_rounded_xl {\n  border-radius: 16px;\n}\n\n.border_rounded_2xl {\n  border-radius: 24px;\n}\n\n.border_rounded_pill {\n  border-radius: 103px;\n}\n\n.border_rounded_full {\n  border-radius: 50%;\n}\n\n.border_rounded_total {\n  border-radius: 100%;\n}\n\n.border_color_neutral_default {\n  border-color: #cbd5e1;\n}\n\n.border_color_neutral_200 {\n  border-color: #e2e8f0;\n}\n\n.border_color_neutral_400 {\n  border-color: #94a3b8;\n}\n\n.border_color_purple_default {\n  border-color: #692b7e;\n}\n\n.border_color_purple_100 {\n  border-color: #d1bdd7;\n}\n\n.border_color_purple_500 {\n  border-color: #692b7e;\n}\n\n.flex_vertical {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.flex_horizontal {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.elipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.company_type_badge {\n  display: flex;\n  width: 100%;\n}\n.company_type_badge .iconn_svg {\n  margin-top: -3px;\n  margin-right: 4px;\n}\n.company_type_badge span {\n  text-transform: uppercase;\n}",".bold-headline-h1-xl {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 40px;\n  line-height: 140%;\n}\n\n.bold-headline-h2-lg {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 140%;\n}\n\n.bold-headline-h3-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 140%;\n}\n\n.bold-headline-h4-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 140%;\n}\n\n.medium-headline-h1-xl {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 40px;\n  line-height: 140%;\n}\n\n.medium-headline-h2-lg {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 32px;\n  line-height: 140%;\n}\n\n.medium-headline-h3-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 140%;\n}\n\n.medium-headline-h4-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 140%;\n}\n\n.regular-headline-h1-xl {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 40px;\n  line-height: 140%;\n}\n\n.regular-headline-h2-lg {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 32px;\n  line-height: 140%;\n}\n\n.regular-headline-h3-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 140%;\n}\n\n.regular-headline-h4-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 140%;\n}\n\n.bold-subtitle-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 140%;\n}\n\n.bold-subtitle-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 140%;\n}\n\n.medium-subtitle-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 135%;\n}\n\n.medium-subtitle-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 140%;\n}\n\n.regular-subtitle-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 140%;\n}\n\n.regular-subtitle-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 140%;\n}\n\n.bold-body-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.bold-body-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.medium-body-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.medium-body-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.regular-body-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.regular-body-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.bold-caption-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 140%;\n}\n\n.bold-caption-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 140%;\n}\n\n.medium-caption-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 140%;\n}\n\n.medium-caption-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 10px;\n  line-height: 140%;\n}\n\n.regular-caption-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 140%;\n}\n\n.regular-caption-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 140%;\n}\n\n.bold-overline-xl {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.bold-overline-lg {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.bold-overline-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n.bold-overline-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 150%;\n}\n\n.medium-overline-xl {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.medium-overline-lg {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.medium-overline-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n.medium-overline-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 10px;\n  line-height: 150%;\n}\n\n.regular-overline-xl {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n}\n\n.regular-overline-lg {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n.regular-overline-md {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n.regular-overline-sm {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 150%;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\n.lowercase {\n  text-transform: lowercase;\n}\n\n.underline {\n  text-decoration: underline;\n}",".margin-top {\n  &_3xs {\n    margin-top: calc(8px / 4);\n  }\n  &_2xs {\n    margin-top: calc(8px / 2);\n  }\n  &_xs-df {\n    margin-top: calc(8px);\n  }\n  &_sm {\n    margin-top: calc(2*8px);\n  }\n  &_md {\n    margin-top: calc(3*8px);\n  }\n  &_lg {\n    margin-top: calc(4*8px);\n  }\n  &_xl {\n    margin-top: calc(5*8px);\n  }\n  &_2xl {\n    margin-top: calc(6*8px);\n  }\n  &_3xl {\n    margin-top: calc(7*8px);\n  }\n  &_4xl {\n    margin-top: calc(8*8px);\n  }\n  &_5xl {\n    margin-top: calc(9*8px);\n  }\n  &_6xl {\n    margin-top: calc(10*8px);\n  }\n  &_7xl {\n    margin-top: calc(16*8px);\n  }\n};\n\n.margin-right {\n  &_3xs {\n    margin-right: calc(8px / 4);\n  }\n  &_2xs {\n    margin-right: calc(8px / 2);\n  }\n  &_xs-df {\n    margin-right: calc(8px);\n  }\n  &_sm {\n    margin-right: calc(2*8px);\n  }\n  &_md {\n    margin-right: calc(3*8px);\n  }\n  &_lg {\n    margin-right: calc(4*8px);\n  }\n  &_xl {\n    margin-right: calc(5*8px);\n  }\n  &_2xl {\n    margin-right: calc(6*8px);\n  }\n  &_3xl {\n    margin-right: calc(7*8px);\n  }\n  &_4xl {\n    margin-right: calc(8*8px);\n  }\n  &_5xl {\n    margin-right: calc(9*8px);\n  }\n  &_6xl {\n    margin-right: calc(10*8px);\n  }\n  &_7xl {\n    margin-right: calc(16*8px);\n  }\n};\n\n.margin-bottom {\n  &_3xs {\n    margin-bottom: calc(8px / 4);\n  }\n  &_2xs {\n    margin-bottom: calc(8px / 2);\n  }\n  &_xs-df {\n    margin-bottom: calc(8px);\n  }\n  &_sm {\n    margin-bottom: calc(2*8px);\n  }\n  &_md {\n    margin-bottom: calc(3*8px);\n  }\n  &_lg {\n    margin-bottom: calc(4*8px);\n  }\n  &_xl {\n    margin-bottom: calc(5*8px);\n  }\n  &_2xl {\n    margin-bottom: calc(6*8px);\n  }\n  &_3xl {\n    margin-bottom: calc(7*8px);\n  }\n  &_4xl {\n    margin-bottom: calc(8*8px);\n  }\n  &_5xl {\n    margin-bottom: calc(9*8px);\n  }\n  &_6xl {\n    margin-bottom: calc(10*8px);\n  }\n  &_7xl {\n    margin-bottom: calc(16*8px);\n  }\n};\n\n.margin-left {\n  &_3xs {\n    margin-left: calc(8px / 4);\n  }\n  &_2xs {\n    margin-left: calc(8px / 2);\n  }\n  &_xs-df {\n    margin-left: calc(8px);\n  }\n  &_sm {\n    margin-left: calc(2*8px);\n  }\n  &_md {\n    margin-left: calc(3*8px);\n  }\n  &_lg {\n    margin-left: calc(4*8px);\n  }\n  &_xl {\n    margin-left: calc(5*8px);\n  }\n  &_2xl {\n    margin-left: calc(6*8px);\n  }\n  &_3xl {\n    margin-left: calc(7*8px);\n  }\n  &_4xl {\n    margin-left: calc(8*8px);\n  }\n  &_5xl {\n    margin-left: calc(9*8px);\n  }\n  &_6xl {\n    margin-left: calc(10*8px);\n  }\n  &_7xl {\n    margin-left: calc(16*8px);\n  }\n};\n\n.margin {\n  &_3xs {\n    margin: calc(8px / 4);\n  }\n  &_2xs {\n    margin: calc(8px / 2);\n  }\n  &_xs-df {\n    margin: calc(8px);\n  }\n  &_sm {\n    margin: calc(2*8px);\n  }\n  &_md {\n    margin: calc(3*8px);\n  }\n  &_lg {\n    margin: calc(4*8px);\n  }\n  &_xl {\n    margin: calc(5*8px);\n  }\n  &_2xl {\n    margin: calc(6*8px);\n  }\n  &_3xl {\n    margin: calc(7*8px);\n  }\n  &_4xl {\n    margin: calc(8*8px);\n  }\n  &_5xl {\n    margin: calc(9*8px);\n  }\n  &_6xl {\n    margin: calc(10*8px);\n  }\n  &_7xl {\n    margin: calc(16*8px);\n  }\n};\n\n.padding-top {\n  &_3xs {\n    padding-top: calc(8px / 4);\n  }\n  &_2xs {\n    padding-top: calc(8px / 2);\n  }\n  &_xs-df {\n    padding-top: calc(8px);\n  }\n  &_sm {\n    padding-top: calc(2*8px);\n  }\n  &_md {\n    padding-top: calc(3*8px);\n  }\n  &_lg {\n    padding-top: calc(4*8px);\n  }\n  &_xl {\n    padding-top: calc(5*8px);\n  }\n  &_2xl {\n    padding-top: calc(6*8px);\n  }\n  &_3xl {\n    padding-top: calc(7*8px);\n  }\n  &_4xl {\n    padding-top: calc(8*8px);\n  }\n  &_5xl {\n    padding-top: calc(9*8px);\n  }\n  &_6xl {\n    padding-top: calc(10*8px);\n  }\n  &_7xl {\n    padding-top: calc(16*8px);\n  }\n};\n\n.padding-right {\n  &_3xs {\n    padding-right: calc(8px / 4);\n  }\n  &_2xs {\n    padding-right: calc(8px / 2);\n  }\n  &_xs-df {\n    padding-right: calc(8px);\n  }\n  &_sm {\n    padding-right: calc(2*8px);\n  }\n  &_md {\n    padding-right: calc(3*8px);\n  }\n  &_lg {\n    padding-right: calc(4*8px);\n  }\n  &_xl {\n    padding-right: calc(5*8px);\n  }\n  &_2xl {\n    padding-right: calc(6*8px);\n  }\n  &_3xl {\n    padding-right: calc(7*8px);\n  }\n  &_4xl {\n    padding-right: calc(8*8px);\n  }\n  &_5xl {\n    padding-right: calc(9*8px);\n  }\n  &_6xl {\n    padding-right: calc(10*8px);\n  }\n  &_7xl {\n    padding-right: calc(16*8px);\n  }\n};\n\n.padding-bottom {\n  &_3xs {\n    padding-bottom: calc(8px / 4);\n  }\n  &_2xs {\n    padding-bottom: calc(8px / 2);\n  }\n  &_xs-df {\n    padding-bottom: calc(8px);\n  }\n  &_sm {\n    padding-bottom: calc(2*8px);\n  }\n  &_md {\n    padding-bottom: calc(3*8px);\n  }\n  &_lg {\n    padding-bottom: calc(4*8px);\n  }\n  &_xl {\n    padding-bottom: calc(5*8px);\n  }\n  &_2xl {\n    padding-bottom: calc(6*8px);\n  }\n  &_3xl {\n    padding-bottom: calc(7*8px);\n  }\n  &_4xl {\n    padding-bottom: calc(8*8px);\n  }\n  &_5xl {\n    padding-bottom: calc(9*8px);\n  }\n  &_6xl {\n    padding-bottom: calc(10*8px);\n  }\n  &_7xl {\n    padding-bottom: calc(16*8px);\n  }\n};\n\n.padding-left {\n  &_3xs {\n    padding-left: calc(8px / 4);\n  }\n  &_2xs {\n    padding-left: calc(8px / 2);\n  }\n  &_xs-df {\n    padding-left: calc(8px);\n  }\n  &_sm {\n    padding-left: calc(2*8px);\n  }\n  &_md {\n    padding-left: calc(3*8px);\n  }\n  &_lg {\n    padding-left: calc(4*8px);\n  }\n  &_xl {\n    padding-left: calc(5*8px);\n  }\n  &_2xl {\n    padding-left: calc(6*8px);\n  }\n  &_3xl {\n    padding-left: calc(7*8px);\n  }\n  &_4xl {\n    padding-left: calc(8*8px);\n  }\n  &_5xl {\n    padding-left: calc(9*8px);\n  }\n  &_6xl {\n    padding-left: calc(10*8px);\n  }\n  &_7xl {\n    padding-left: calc(16*8px);\n  }\n};\n\n.padding {\n  &_3xs {\n    padding: calc(8px / 4);\n  }\n  &_2xs {\n    padding: calc(8px / 2);\n  }\n  &_xs-df {\n    padding: calc(8px);\n  }\n  &_sm {\n    padding: calc(2*8px);\n  }\n  &_md {\n    padding: calc(3*8px);\n  }\n  &_lg {\n    padding: calc(4*8px);\n  }\n  &_xl {\n    padding: calc(5*8px);\n  }\n  &_2xl {\n    padding: calc(6*8px);\n  }\n  &_3xl {\n    padding: calc(7*8px);\n  }\n  &_4xl {\n    padding: calc(8*8px);\n  }\n  &_5xl {\n    padding: calc(9*8px);\n  }\n  &_6xl {\n    padding: calc(10*8px);\n  }\n  &_7xl {\n    padding: calc(16*8px);\n  }\n};\n\n",".width {\n  &_xs-df {\n    width: calc(8px);\n  }\n  &_sm {\n    width: calc(2*8px);\n  }\n  &_md {\n    width: calc(3*8px);\n  }\n  &_lg {\n    width: calc(4*8px);\n  }\n  &_xl {\n    width: calc(5*8px);\n  }\n  &_2xl {\n    width: calc(6*8px);\n  }\n  &_3xl {\n    width: calc(7*8px);\n  }\n  &_4xl {\n    width: calc(8*8px);\n  }\n  &_5xl {\n    width: calc(9*8px);\n  }\n  &_6xl {\n    width: calc(10*8px);\n  }\n  &_7xl {\n    width: calc(16*8px);\n  }\n  &_xs-df-important {\n    width: calc(8px) !important;\n  }\n  &_sm-important {\n    width: calc(2*8px) !important;\n  }\n  &_md-important {\n    width: calc(3*8px) !important;\n  }\n  &_lg-important {\n    width: calc(4*8px) !important;\n  }\n  &_xl-important {\n    width: calc(5*8px) !important;\n  }\n  &_2xl-important {\n    width: calc(6*8px) !important;\n  }\n  &_3xl-important {\n    width: calc(7*8px) !important;\n  }\n  &_4xl-important {\n    width: calc(8*8px) !important;\n  }\n  &_5xl-important {\n    width: calc(9*8px) !important;\n  }\n  &_6xl-important {\n    width: calc(10*8px) !important;\n  }\n  &_7xl-important {\n    width: calc(16*8px) !important;\n  }\n};\n\n.height {\n  &_xs-df {\n    height: calc(8px);\n  }\n  &_sm {\n    height: calc(2*8px);\n  }\n  &_md {\n    height: calc(3*8px);\n  }\n  &_lg {\n    height: calc(4*8px);\n  }\n  &_xl {\n    height: calc(5*8px);\n  }\n  &_2xl {\n    height: calc(6*8px);\n  }\n  &_3xl {\n    height: calc(7*8px);\n  }\n  &_4xl {\n    height: calc(8*8px);\n  }\n  &_5xl {\n    height: calc(9*8px);\n  }\n  &_6xl {\n    height: calc(10*8px);\n  }\n  &_7xl {\n    height: calc(16*8px);\n  }\n  &_xs-df-important {\n    height: calc(8px) !important;\n  }\n  &_sm-important {\n    height: calc(2*8px) !important;\n  }\n  &_md-important {\n    height: calc(3*8px) !important;\n  }\n  &_lg-important {\n    height: calc(4*8px) !important;\n  }\n  &_xl-important {\n    height: calc(5*8px) !important;\n  }\n  &_2xl-important {\n    height: calc(6*8px) !important;\n  }\n  &_3xl-important {\n    height: calc(7*8px) !important;\n  }\n  &_4xl-important {\n    height: calc(8*8px) !important;\n  }\n  &_5xl-important {\n    height: calc(9*8px) !important;\n  }\n  &_6xl-important {\n    height: calc(10*8px) !important;\n  }\n  &_7xl-important {\n    height: calc(16*8px) !important;\n  }\n};\n\n$spacer: 8px;\n$sizes: (\n    0: $spacer * 0,   // 0\n    1: $spacer * .25, // 2\n    2: $spacer * .5,  // 4\n    3: $spacer * 1,   // 8\n    4: $spacer * 1.5, // 12\n    5: $spacer * 2,   // 16\n    6: $spacer * 3,   // 24\n    7: $spacer * 4,   // 32\n    8: $spacer * 5,   // 40\n);\n\n@function size($key) {\n  @return map-get($sizes, $key);\n}\n\n","$grid_padding_top: 64px;\n$grid_border_radius: 8px;\n$grid_border: 1px solid #E5E5E5;\n$grid_background: #F4F6FC;\n\n$grids: (\n  \"grid-600\": (\n    \"height\": 960px,\n    \"width\": 600px,\n    \"padding-top\": $grid_padding_top,\n    \"padding-left\": 0px,\n    \"border-radius\": $grid_border_radius,\n    \"border\": $grid_border,\n    'background': $grid_background,\n  ),\n  \"grid-900\": (\n    \"height\": 960px,\n    \"width\": 900px,\n    \"padding-top\": $grid_padding_top,\n    \"padding-left\": 0px,\n    \"border-radius\": $grid_border_radius,\n    \"border\": $grid_border,\n    'background': $grid_background,\n  ),\n  \"grid-1240\": (\n    \"height\": 960px,\n    \"width\": 1240px,\n    \"padding-top\": $grid_padding_top,\n    \"padding-left\": 0px,\n    \"border-radius\": $grid_border_radius,\n    \"border\": $grid_border,\n    'background': $grid_background,\n  ),\n  \"grid-1440\": (\n    \"height\": 960px,\n    \"width\": 1440px,\n    \"padding-top\": $grid_padding_top,\n    \"padding-left\": 0px,\n    \"padding-color\": white,\n    \"border-radius\": $grid_border_radius,\n    \"border\": $grid_border,\n    'background': $grid_background,\n  ),\n  \"grid-600-sidebar\": (\n    \"height\": 960px,\n    \"width\": 600px,\n    \"padding-top\": $grid_padding_top,\n    \"padding-left\": 80px,\n    \"border-radius\": $grid_border_radius,\n    \"border\": $grid_border,\n    'background': $grid_background,\n  ),\n  \"grid-900-sidebar\": (\n    \"height\": 960px,\n    \"width\": 900px,\n    \"padding-top\": $grid_padding_top,\n    \"padding-left\": 80px,\n    \"border-radius\": $grid_border_radius,\n    \"border\": $grid_border,\n    'background': $grid_background,\n  ),\n  \"grid-1240-sidebar\": (\n    \"height\": 960px,\n    \"width\": 1240px,\n    \"padding-top\": $grid_padding_top,\n    \"padding-left\": 296px,\n    \"border-radius\": $grid_border_radius,\n    \"border\": $grid_border,\n    'background': $grid_background,\n  ),\n  \"grid-1440-sidebar\": (\n    \"height\": 960px,\n    \"width\": 1440px,\n    \"padding-top\": $grid_padding_top,\n    \"padding-left\": 296px,\n    \"border-radius\": $grid_border_radius,\n    \"border\": $grid_border,\n    'background': $grid_background,\n  ),\n);\n\n@each $grid-name, $grid-value in $grids {\n  .grid-#{$grid-name} {\n    @each $name, $value in $grid-value {\n      #{$name}: #{$value}\n    }\n  }\n}",".gray-shadow-xs {\n  box-shadow: 2px 4px 12px -2px #F1F5F9;\n}\n\n.gray-shadow-sm-df {\n  box-shadow: 2px 4px 24px -4px #E2E8F0;\n}\n\n.gray-shadow-md {\n  box-shadow: 2px 4px 24px -4px #E2E8F0;\n}\n\n.gray-shadow-lg {\n  box-shadow: 4px 16px 32px -12px #F1F5F9, 2px 24px 48px #F1F5F9;\n}\n\n.gray-shadow-xl {\n  box-shadow: 8px 24px 48px -16px #F1F5F9, 4px 32px 64px #F1F5F9;\n}\n\n.inner-shadow-xs-df {\n  box-shadow: inset 0px 2px 8px -2px #E2E8F0;\n}\n\n.inner-shadow-sm {\n  box-shadow: inset 2px 4px 16px #E2E8F0;\n}\n\n.inner-shadow-md {\n  box-shadow: inset 4px 8px 24px #E2E8F0;\n}\n\n.inner-shadow-lg {\n  box-shadow: inset 8px 8px 32px #E2E8F0;\n}\n\n.inner-shadow-xl {\n  box-shadow: inset 16px 24px 48px #E2E8F0;\n}\n\n.alt-shadow-xs {\n  box-shadow: 2px 4px 12px -2px #F0EAF2;\n}\n\n.alt-shadow-sm-df {\n  box-shadow: 2px 4px 24px -4px #F0EAF2;\n}\n\n.alt-shadow-md {\n  box-shadow: 2px 4px 24px -4px #D1BDD7;\n}\n\n.alt-shadow-lg {\n  box-shadow: 4px 16px 32px -12px #F0EAF2, 2px 24px 48px -8px #F0EAF2;\n}\n\n.alt-shadow-xl {\n  box-shadow: 8px 24px 48px -12px #F0EAF2, 4px 32px 64px -16px #F0EAF2;\n}\n\n.focus-shadow-primary {\n  box-shadow: 0px 0px 0px 3px #BA9DC4;\n}\n\n.focus-shadow-error {\n  box-shadow: 0px 0px 0px 3px #EBA6B3;\n}\n\n.focus-shadow-success {\n  box-shadow: 0px 0px 0px 3px #98EBD7;\n}\n\n.focus-shadow-warning {\n  box-shadow: 0px 0px 0px 3px #F5C25F;\n}\n\n.focus-shadow-info {\n  box-shadow: 0px 0px 0px 3px #AEBFF0;\n}",".border_stroke_sm_df {\n  border-width: 1px;\n  border-style: solid;\n}\n\n.border_stroke_md {\n  border-width: 2px;\n  border-style: solid;\n}\n\n.border_stroke_lg {\n  border-width: 4px;\n  border-style: solid;\n}\n\n.border_rounded_none {\n  border-radius: 0;\n}\n\n.border_rounded_sm {\n  border-radius: 2px;\n}\n\n.border_rounded_md_df {\n  border-radius: 4px;\n}\n\n.border_rounded_lg {\n  border-radius: 8px;\n}\n\n.border_rounded_xl {\n  border-radius: 16px;\n}\n\n.border_rounded_2xl {\n  border-radius: 24px;\n}\n\n.border_rounded_pill {\n  border-radius: 103px;\n}\n\n.border_rounded_full {\n  border-radius: 50%;\n}\n\n.border_rounded_total {\n  border-radius: 100%;\n}\n\n.border_color_neutral_default {\n  border-color: map-get($neutral, 'neutral-300');\n}\n\n.border_color_neutral_200 {\n  border-color: map-get($neutral, 'neutral-200');\n}\n\n.border_color_neutral_400 {\n  border-color: map-get($neutral, 'neutral-400');\n}\n\n.border_color_purple_default {\n  border-color: map-get($primary, 'purple-500');\n}\n\n.border_color_purple_100 {\n  border-color: map-get($primary, 'purple-100');\n}\n\n.border_color_purple_500 {\n  border-color: map-get($primary, 'purple-500');\n}\n",".flex_vertical {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.flex_horizontal {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.elipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}","\n@import \"@foundation\";\n\n.company_type_badge {\n  display: flex;\n  width: 100%;\n\n  .iconn_svg {\n    margin-top: -3px;\n    margin-right: 4px;\n  }\n\n  span {\n    text-transform: uppercase;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
